import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M12 17q.425 0 .7125-.2875Q13 16.4249 13 16t-.2875-.7125Q12.425 15 12 15t-.7125.2875T11 16t.2875.7125T12 17m-1-4h2V7h-2zm1 9q-2.075 0-3.9-.7875T4.925 19.075 2.7875 15.9 2 12t.7875-3.9T4.925 4.925 8.1 2.7875 12 2t3.9.7875 3.175 2.1375T21.2125 8.1 22 12t-.7875 3.9-2.1375 3.175-3.175 2.1375T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20" /></g>,<defs key="1"></defs>,]
, 'DisplayAlertOutlinedx');
